/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

/**
 * 后端灰度开启开关列表（比如草稿箱列表传"list_draft"、创建活动传"create_event"）
 */
export type GraySwitch = string[];
export interface ActivitiesEntryBatchRes {
  data: Data;
  msg: string;
  code: number;
  nonce: string;
}
export interface Data {
  /**
   * 是否展示活动空间
   */
  is_show_activity_room: boolean;
  /**
   * 是否有主办方身份
   */
  is_host: boolean;
  /**
   * 是否是主办方内测用户
   */
  is_beta_user: boolean;
  gray_switch: GraySwitch;
  /**
   * 是否拥有付费资格(该字段废弃，请勿再使用)
   */
  has_payment_qualification: boolean;
  /**
   * 是否为主办方组织成员
   */
  is_host_org_member: boolean;
  /**
   * 是否展示活动广场
   */
  is_show_activity_plaza: string;
}

const ActivitiesEntryBatch = async (ctx?: GetServerSidePropsContext) => {
  const res = await http.post<ActivitiesEntryBatchRes>(
    '/wemeet-tapi',
    '/v2/activities/entry/batch',
    {},
    ctx,
  );

  return res;
};

export default ActivitiesEntryBatch;
